import moment from "moment";

export const dateFormat = (format: string) =>
  (val: number | string) => moment(val).format(format);

/**
 * The events query's `toDate` is exclusive: asked for "2026-09-22" it stops
 * before that day, so the day the user picked was missing from the list. A
 * range the reader means as "up to and including the 22nd" is therefore sent
 * as the 23rd, and the end of a month rolls into the next one (task 25077).
 */
export const inclusiveToDate = (date: string) =>
  moment(date).add(1, "day").format("YYYY-MM-DD");
